<template>
  <div class="container-fluid h-100">
    <div class="container" id="container_discounts">
      <div class="row mt-5 pt-3">
        <div style="display:flex;" class="col-lg-6 col-8 mt-2">
          <h6 style="margin:auto 10px auto auto;" class="text-dark font-weight-bold">
            Filtrar por tipo de catálogo (Motero por defecto)
          </h6>
          <select class="form-control" name="type" id="type" 
            v-model="typeId"
            v-on:change="searchType()"
          >
            <option value="null" disabled selected>Seleccione el tipo de catálogo</option>
            <option value="1">Motero</option>
            <option value="2">Lubricador</option>
            <option value="3">Motero y Lubricador</option>
          </select>
        </div>

        <div class="col-lg-2 col-4 mt-2">
          <button
            @click="selectAll()"
            type="button"
            class="btn btn-info btn-block" 
          >
            Seleccionar todo
          </button>
        </div>

        <div style="text-align:end;" class="col-lg-4 col-8 mt-2">
          <button
            v-if="arrayProducts.length > 0"
            @click="showModalDiscounts()"
            type="button"
            class="btn btn-success"
          >
            Aplicar / Quitar descuento a los productos seleccionados
          </button>
        </div>
      </div>

      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width:4em; height:4rem; margin:50px"
            role="status"
          ></div>
        </div>
      </template>

      <paginate
        v-else
        class="ul-pagination"
        name="items"
        :list="items"
        :per="items.length"
      >
        <div class="row mt-1">
          <div class="col-lg-12 col-12">
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <caption class="visually-hidden">Listado de Descuentos</caption>
                <thead>
                  <tr>
                    <th scope="col" style="text-align: left">Imagen</th>
                    <th scope="col" style="text-align: left">Nombre</th>
                    <th scope="col" style="text-align: left">Puntos</th>
                    <th scope="col" style="text-align: left">Puntos con descuento</th>
                    <th scope="col" style="text-align: left">Porcentaje aplicado</th>
                    <th scope="col" style="text-align: left">Estado</th>
                    <th scope="col" style="text-align: left">Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in paginated('items')"
                    :key="'d' + `item-${i}`"
                  >
                    <td style="text-align: left">
                      <img
                        width="100"
                        class="img-item"
                        :src="item.img"
                        :alt="item.name"
                      />
                    </td>
                    <td style="text-align: left">
                      {{ item.name }}
                    </td>
                    <td style="text-align: left">
                      <h6>
                        <span v-if="item.type_catalogue == 2" class="badge badge-pill badge-danger">
                          Puntos: {{ item.points_lub }}
                        </span>
                        <span v-else-if="item.type_catalogue == 3" class="badge badge-pill badge-danger">
                          Motero: {{ item.points }}&nbsp; - &nbsp;
                          Lubricador: {{ item.points_lub }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger">
                          Puntos: {{ item.points }}
                        </span>
                      </h6>
                    </td>

                    <td style="text-align: left">
                      <h6>
                        <span v-if="item.type_catalogue == 2" class="badge badge-pill badge-danger">
                          Puntos: {{ item.discount_lub != null ? item.points_discount_lub : item.points_lub }}
                        </span>
                        <span v-else-if="item.type_catalogue == 3" class="badge badge-pill badge-danger">
                          Motero: {{ item.discount != null ? item.points_discount : item.points }}&nbsp; - &nbsp;
                          Lubricador: {{ item.discount_lub != null ? item.points_discount_lub : item.points_lub }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger">
                          Puntos: {{ item.discount != null ? item.points_discount : item.points }}
                        </span>
                      </h6>
                    </td>

                    <td style="text-align: left">
                      <span v-if="item.type_catalogue == 2">
                        <span v-if="item.discount_lub != null" class="badge badge-pill badge-success">
                          {{ item.discount_lub }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger">
                          {{ '0%' }}
                        </span>
                      </span>
                      <span v-else-if="item.type_catalogue == 3">
                        <span v-if="item.discount != null" class="badge badge-pill badge-success">
                          {{ 'Motero ' + item.discount }} - {{ 'Lubricador ' + item.discount_lub }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger">
                          {{ '0%' }}
                        </span>
                      </span>
                      <span v-else>
                        <span v-if="item.discount != null" class="badge badge-pill badge-success">
                          {{ item.discount }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger">
                          {{ '0%' }}
                        </span>
                      </span>
                    </td>

                    <td style="text-align: left">
                      <label v-if="item.status_id == 1" style="color: #dc3545">
                        {{ item.status.name }}
                      </label>
                      <label v-else style="color: gray">
                        {{ item.status.name }}
                      </label>
                    </td>
                    <td style="text-align:center">
                      <input
                        type="checkbox"
                        :value="item.id"
                        v-model="arrayProducts"
                        @change="addProduct(item.id)"
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </paginate>

      <div class="row ">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
        >
          <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
        </div>
        <div
          class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
        >
          <paginate-links
            @change="pageChange"
            for="items"
            :limit="2"
            :show-step-links="true"
            :step-links="{ next: '>', prev: '<' }"
            :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
          >
          </paginate-links>
        </div>
      </div>

      <!-- Popup para aplicar porcentaje de descuento -->
      <div
        class="modal fade"
        id="popupDiscount"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div style="padding:10px 20px 10px 20px" class="modal-content">
            <div id="boton_cerrar">
              <button
                type="button"
                class="close close-info-l"
                @click="closedModal()"
              >
                X
              </button>
            </div>
            <div>
              <p style="color:#616161; font-size:18px;">
                <strong>Aplicar / Quitar % de descuento</strong>
              </p>

              <div v-if="typeId == 1 || typeId == 3" class="col-12">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color: #616161; font-size: 14px"
                    ><strong>Descuento catálogo Motero *</strong>
                  </label>
                  <input
                    :class="{ 'is-danger': errors.percentageDiscount }"
                    type="text"
                    v-model="percentagePoints"
                    class="form-control"
                    placeholder="Escribe aquí el porcentaje de descuento"
                    maxlength="3"
                  />
                </div>
                <span
                  v-if="errors.percentageDiscount"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.percentageDiscount }}</span
                >
              </div><br>
              <div v-if="typeId == 2 || typeId == 3" class="col-12">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color: #616161; font-size: 14px"
                    ><strong>Descuento catálogo Lubricador *</strong>
                  </label>
                  <input
                    :class="{ 'is-danger': errors.percentageDiscountLub }"
                    type="text"
                    v-model="percentagePointsLub"
                    class="form-control"
                    placeholder="Escribe aquí el porcentaje de descuento"
                    maxlength="3"
                  />
                </div>
                <span
                  v-if="errors.percentageDiscountLub"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.percentageDiscountLub }}</span
                >
              </div><br>

              <template>
                <button
                  type="button"
                  class="btn btn-success mb-3 ml-3"
                  @click="createDiscounts()"
                >
                  <template v-if="loading.saveDiscount">
                    <div style="padding:0px 20px;" class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width:2em; height:2rem; color:white !important;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    Dar descuento
                  </template>
                </button>
              </template>

              <template>
                <button
                  type="button"
                  class="btn btn-danger mb-3 ml-3"
                  @click="deleteDiscounts()"
                >
                  <template v-if="loading.deleteDiscount">
                    <div style="padding:0px 20px;" class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width:2em; height:2rem; color:white !important;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    Quitar descuento
                  </template>
                </button>
              </template>
              
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
  
<script>
  import $ from "jquery";
  import axios from "axios";
  
  export default {
    data() {
      return {
        form: {
          id: 0,
          percentageDiscount: 5,
          percentageDiscountLub: 5,
        },
        errors: {
          id: 0,
          percentageDiscount: false,
          percentageDiscountLub: false,
        },
        typeId: 1,
        currentForm: {},
        loading: {
          history: false,
          saveDiscount: false,
          deleteDiscount: false,
        },
        hidden: {
          btn: false,
        },
        paginate: ["items"],
        page: 1,
        totalPage: 1,

        arrayProducts: [],
      };
    },

    computed: {
      percentagePoints: {
        get() {
          return this.form.percentageDiscount + '%';
        },
        set(newValue) {
          this.form.percentageDiscount = newValue.replace('%', '');
        },
      },
      percentagePointsLub: {
        get() {
          return this.form.percentageDiscountLub + '%';
        },
        set(newValue) {
          this.form.percentageDiscountLub = newValue.replace('%', '');
        },
      },
    },

    methods: {
      searchType() {
        this.items = [];
        this.loading.history = true;
        if (this.typeId != null) {
          axios
          .get("superAdmin/products/by/type/" + this.typeId)
          .then((res) => {
            if (res.data.cod == 0) {
              const dataTemp = res.data.data
              dataTemp.map((item) => {
                if(item.status_id == 1){
                  this.items.push(item)
                }
              })
              this.totalPage = Math.ceil(parseInt(this.items.length) / 1);
              this.arrayProducts = [];
              this.errors.percentageDiscount = false;
              this.errors.percentageDiscountLub = false;
            }
            this.loading.history = false;
          })
          .catch((error) => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
        }
      },
      selectAll(){
        const allIds = this.items.map(item => item.id);
        this.arrayProducts = allIds;
      },
      addProduct(item){
        if (item.checked) {
          this.arrayProducts.push(item);
        } else {
          this.arrayProducts.splice(item, 1);
        }
      },
      showModalDiscounts(){
        $("#popupDiscount").modal("show");
      },
      closedModal(){
        $("#popupDiscount").modal("hide");
      },
      validform() {
        let app = this;
        if(app.typeId == 1 || app.typeId == 3){
          if (!app.form.percentageDiscount) {
            app.errors.percentageDiscount = "El porcentaje es requerido.";
            return false;
          }
        }
        else if(app.typeId == 2 || app.typeId == 3){
          if (!app.form.percentageDiscountLub) {
            app.errors.percentageDiscountLub = "El porcentaje es requerido.";
            return false;
          }
        }
        if (!app.errors.percentageDiscount && !app.errors.percentageDiscountLub) {
          return true;
        } else {
          return false;
        }
      },
      createDiscounts() {
        let app = this;
        if (app.validform()) {
          app.saveDiscounts();
        }
      },
      saveDiscounts() {
        let data = {
          typeId: this.typeId,
          percentageDiscount: this.form.percentageDiscount,
          percentageDiscountLub: this.form.percentageDiscountLub,
          arrayProducts: this.arrayProducts
        }
        this.loading.saveDiscount = true;
        axios
          .post("superAdmin/products/apply/discount", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.saveDiscount = false;
              $("#popupDiscount").modal("hide");
              this.searchType();
              this.form.percentageDiscount = 5;
              this.form.percentageDiscountLub = 5;
              this.arrayProducts = [];
            } else {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "warning",
                title: "Oops",
                text: res.data.message,
              });
              this.loading.saveDiscount = false;
            }
          })
          .catch((error) => {
            this.loading.saveDiscount = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      deleteDiscounts() {
        let data = {
          typeId: this.typeId,
          arrayProducts: this.arrayProducts
        }
        this.loading.deleteDiscount = true;
        axios
          .post("superAdmin/products/delete/discount", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.deleteDiscount = false;
              $("#popupDiscount").modal("hide");
              this.searchType();
              this.form.percentageDiscount = 5;
              this.form.percentageDiscountLub = 5;
              this.arrayProducts = [];
            } else {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "warning",
                title: "Oops",
                text: res.data.message,
              });
              this.loading.deleteDiscount = false;
            }
          })
          .catch((error) => {
            this.loading.deleteDiscount = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      pageChange(toPage) {
        this.page = toPage;
      },
    },
    mounted() {
      this.pageChange(1);
      this.searchType();
    },
    watch: {
      "form.percentageDiscount": function(newV) {
        if (!newV) {
          this.errors.percentageDiscount = "El porcentaje es requerido.";
        } else {
          this.errors.percentageDiscount = false;
        }
      },
      "form.percentageDiscountLub": function(newV) {
        if (!newV) {
          this.errors.percentageDiscountLub = "El porcentaje es requerido.";
        } else {
          this.errors.percentageDiscountLub = false;
        }
      },
    },
  };
</script>
  
<style>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
  }
  #container_discounts{
    min-width: 95%;
  }
  .div-button {
    margin-top: 50px;
    text-align: left;
  }
  .is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
  }
  .modal-title {
    color: black;
    font-weight: bold;
  }
  .modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
  }
  label {
    color: black;
    margin-right: 4px;
  }
  .img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
  }
  td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
  }
  .table-container {
    overflow: auto;
  }
  h5 {
    margin-bottom: 10px !important;
  }
  .commentary {
    text-align: left;
    color: #1da5df;
    font-size: 14px;
  }
  .page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;
  }
  a.page-link {
    color: black;
    cursor: pointer;
  }
  a.page-link:hover {
    color: #dc3545;
  }
  .page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
  }
  .page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
  }
  .ul-pagination {
    padding: 0px;
  }
  #boton_cerrar {
    height: 30px;
    background-color: #fff;
    padding: 3px 6px 0px 0px;
    border-radius: 50px;
    cursor: pointer;
    z-index: 10;
  }
  #boton_cerrar button{
    color: #dc3545;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>
  